import { ElementRef } from '@angular/core';
import { AfterViewInit, Component, ViewChild, OnInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as xlsx from 'xlsx';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { APIService } from 'src/app/api.service';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NgModule } from '@angular/core';
import {Sort} from '@angular/material/sort';

@Component({
  selector: 'app-transaction-history',
  templateUrl: './transaction-history.component.html',
  styleUrls: ['./transaction-history.component.scss']
})
export class TransactionHistoryComponent implements OnInit {

  displayedColumns: string[] = ['Date', 'XnNo', 'storeName', 'outStoreName', 'inStoreName', 'XnByUserName', 'NewinStoreName','Notes', 'Consignee', 'Supplier', 'Action'];
  dataSource = new MatTableDataSource();

  @ViewChild('trasrptable', { static: false }) trasrptable!: ElementRef;


  @ViewChild(MatPaginator)
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  }

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    //this.dataSource.sort = this.sort;
    this.dataSource.sort = this.matSort;
  }

  months: any = [];
  agencyData: any = [];
  jarvisData: any = [];
  userList: any = [];
  trasactionHistoryList: any = [];
  storeList: any = [];
  unitList: Array<any> = [];
  exportToExcel: any = [];
  curDate: any = new Date();
  fromDate = '2021';
  toDate = '2022';
  relativeData: any = [];
  month = this.curDate.getMonth();
  year = this.curDate.getFullYear();
  startDate = new Date();
  endDate = new Date();
  minDate = new Date();
  maxDate = new Date();
  toMinDate = new Date();
  toMaxDate = new Date();

  xnID : number = 0;
  currXnTypeID : number = 0;
  CompID: number = 0;

  store = {
    id: 0,
    name: ""
  };
  user = {
    id: 0,
    name: ""
  };
  transType = {
    id: 0,
    name: ""
  };
  monthDisplay: any
  sNm : string = '';
  userName : string = '';
  StoreName : string = '';
  reletivesData : any = [];
  toUserName : string = '';
  isB2C: boolean = false;  
  showDatePicker: boolean = false;

  transactionType: any = [
    { id: 1, type: "GRN Inverd" },
    { id: 2, type: "Return Unused" },
    { id: 3, type: "Customer Return" },
    { id: 4, type: "Dispatch" },
    { id: 5, type: "Issue" },
    { id: 6, type: "Scrap/Disposal" },
    { id: 7, type: "Production" },
    { id: 8, type: "Reconciliation" },
    { id: 9, type: "Store trasfer" },
    { id: 10, type: "Production" },
    { id: 12, type: "Job Work (Out) - Dispatch History" },
    { id: 13, type: "Job Work (Out) - Receipt History" }
  ]

  xnTypes: any = [
      { typeID: 1, title: 'Inward History' },
      { typeID: 2, title: 'Return History' }, 
      { typeID: 4, title: 'Dispatch History' },
      { typeID: 5, title: 'Issue History' },
      { typeID: 7, title: 'Production History' },
      { typeID: 8, title: 'Recounciliation History' },
      { typeID: 9, title: 'Store Transfer History' },
      { typeID: 12, title: 'Job Work (Out) - Dispatch History' },
      { typeID: 13, title: 'Job Work (Out) - Receipt History' }
  ];

  headerName: string = '';

  constructor(private router: Router, private commonService: CommonService, private apiService: APIService,private Commservice : CommonService) { }

  ngOnInit(): void {
   // this.dataSource.sort = this.sort;
  
   // Get Data from Url
   this.transType.id = Number(decodeURIComponent(this.Commservice.GetParam('XnTypeID') + ''));

    this.months = this.commonService.getMonthYear(new Date('2020-10-01').customFormat("#DD#-#MMM#-#YY#"), new Date().customFormat("#DD#-#MMM#-#YY#"));
    this.monthDisplay = this.months[this.months.length - 1].display;

    let userList = this.apiService.getCookie('J');
    if (userList) {
      this.userList = JSON.parse(userList);
  
    }

    let cnfg = this.apiService.getCookie('ERP_Cfg');
    if (cnfg) {
      let cnfg1 = JSON.parse(cnfg)
      this.storeList = JSON.parse(cnfg1[0].Stores);

      let unit: any = cnfg1[0].Units;
      if(unit){
        this.unitList = JSON.parse(unit);
      }     
    }

    let agencyData = this.apiService.getCookie('M');
    if (agencyData) {
      this.agencyData = JSON.parse(agencyData);
      this.isB2C = this.agencyData[0].IsB2C;
    }
    
    
    // Get XNType Id for Hader Chnage.
    this.currXnTypeID = this.transType.id;
    this.headerName = this.xnTypes.find((type: any) => type.typeID === this.currXnTypeID)?.title || 'No History';
    this.getAllConfig();
    this.trasYearChange();
  }

  getAllConfig() {
    var jarvis = this.apiService.getCookie("Jarvis");
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }

    let data: any = []

    let myParams = [{
      myUserID: this.jarvisData[0].UserID,
      myToken: this.jarvisData[0].WebToken,
      forAgencyID: this.jarvisData[0].AgencyIDs,
      myAgencyIDs: this.jarvisData[0].AgencyIDs,
      myLastSyncDT: null,
      isWeb: true,
      ForERPAgencyID: this.agencyData[0].ERPAgencyID,
      actionType: 'getConfig',
      moduleID: 6,
      data: JSON.stringify(data)
    }];

    this.apiService.getData(myParams, this.successRespGet.bind(this), this.failureRespGet.bind(this));
  }

  failureRespGet(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      this.apiService.successAlert(res.message);
    }
  }

  //successResp - success  get handler
  successRespGet(res: any) {
    if (res.error) {
      console.log(res.message);
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        if (reponseData.Table[0].ErrCode == 1) {
          this.apiService.successAlert(reponseData.Table[0].ErrMsg);
        }
        else {
          let configData = reponseData.Table2;
          if (configData[0].Stores) {
            this.storeList = JSON.parse(configData[0].Stores)

            if (this.jarvisData[0].UserID !== this.agencyData[0].AdminUserID) {
              this.storeList = this.storeList.filter((store: any) => {
                // If no UIDs, everyone has access. If UIDs exists, check if user is included.
                return !store.UIDs || String(store.UIDs).split(',').includes(String(this.jarvisData[0].UserID));
              });
            }
          }
        }

      }
    }
  }

  getData() {
    let userList = this.apiService.getCookie('J');
    if (userList) {
      this.userList = JSON.parse(userList);
    }

    var jarvis = this.apiService.getCookie('Jarvis');
    if (jarvis) {
      this.jarvisData = JSON.parse(jarvis);
    }
    let data = [
      {
        Month: this.month,
        Year: this.year,
        XnTypeID: this.transType.id,
        StoreID: this.store.id,
        XnByUserID: this.user.id
      },
    ];
    let myParams = [
      {
        myUserID: this.jarvisData[0].UserID,
        myToken: this.jarvisData[0].WebToken,
        forAgencyID: this.jarvisData[0].AgencyIDs,
        myAgencyIDs: this.jarvisData[0].AgencyIDs,
        myLastSyncDT: null,
        isWeb: true,
        ForERPAgencyID: this.agencyData[0].ERPAgencyID,
        actionType: 'getInvTransHis',
        moduleID: 12,
        data: JSON.stringify(data),
      },
    ];

    this.apiService.getData(myParams, this.successResp.bind(this), this.failureResp.bind(this)
    );
  }


  successResp(res: any) {
    // this.SpinnerService.hide();
    if (res.error) {
    }
    else {
      if (res) {
        var reponseData = JSON.parse(res.updatePackage);
        //var RelativeList = this.apiService.getCookie('H');
        if (reponseData.Table[0].ErrCode == 1000) {
          alert(reponseData.Table[0].ErrMsg);
          window.location.href = "main.html#/home";
          // this.router.navigateByUrl('/Stock');
        } else {
          if (reponseData.Table[0].ErrCode == -1) {
            this.trasactionHistoryList = reponseData.Table1;
            // if(this.currXnTypeID == 4 || this.currXnTypeID == 1){
            //   if (RelativeList) {
            //     this.relativeData = JSON.parse(RelativeList);
            //   }
            // }

            //Get H from IDB
            var self = this;
            this.apiService.getIDB('H', function(dataList: any){
                if(dataList){ 
                   if(self.currXnTypeID == 4 || self.currXnTypeID == 1){
                    self.relativeData = dataList;
                  }                  
                }   
                
                self.trasactionHistoryList.forEach((p: any) => {           
                  p.storeName = '';
                  p.NewinStoreName = '';
                  if (p.InStoreID) {
                    let inStore = self.storeList.filter((x: any) => x.StrID == p.InStoreID);
                    if(inStore.length > 0){
                      p.inStoreName = inStore[0].sNm;
                    }               
                    p.storeName = p.inStoreName;
                    p.NewinStoreName = p.inStoreName;
                  }
    
                  if (p.OutStoreID) {
                    let outStore = self.storeList.filter((x: any) => x.StrID == p.OutStoreID);
                    if(outStore.length > 0){
                      p.outStoreName = outStore[0].sNm;
                    }              
                    p.storeName = p.outStoreName;
                  }
                  
                  if (p.XnTypeID) {
                    let transType = self.transactionType.filter((x: any) => x.id == p.XnTypeID);
                    // let transType = self.transactionType.filter((x: any) => (p.XnTypeID == 7 ? (x.id == 7 || x.id == 10) : (x.id == p.XnTypeID)));

                    p.transTypeName = transType[0].type;
                  }
    
                  if(self.currXnTypeID == 4 || self.currXnTypeID == 1){
                    let inStore = self.relativeData.filter((x: any) => x.RI == p.RelativeID);
                    if(inStore.length > 0){
                      p.Name = self.isB2C ? inStore[0].Name : inStore[0].Cmp
                    }
                    else{
                      p.Name = ''
                    }
                    
                  }
    
                  p.Date = new Date(p.XnDT).customFormat('#DD#-#MMM#-#YY#')
                });
                console.log(self.trasactionHistoryList)
                self.dataSource.data = self.trasactionHistoryList;
                self.exportToExcel = self.trasactionHistoryList;
                self.dataSource.paginator = self.paginator;
                self.dataSource.sort = self.matSort;
            })  
          }
        }
      }
    }
  }

  //failureResp - failure handler
  failureResp(res: any) {
    if (res.error) {
    } else {
      alert(res.message);
    }
  }

    //export to excel
    tableToExcel = (function () {
      var uri = 'data:application/vnd.ms-excel;base64,'
          , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body>{table}</body></html>'
          , base64 = function (s:any) { return window.btoa(unescape(encodeURIComponent(s))) }
          , format = function (s:any, c:any) { return s.replace(/{(\w+)}/g, function (m:any, p:any) { return c[p]; }) }
  
      return function (table: any, name : string, fileName:any) {
          if (!table.nodeType) table = table
          var ctx = { worksheet: name || 'Worksheet', table: table }
          //window.location.href = uri + base64(format(template, ctx))
          var link = document.createElement("a");
          link.download = fileName || 'download.xls';
          link.href = uri + base64(format(template, ctx));
          link.click();
      }
    })()

  backBtn() {
    this.router.navigate(['/Stock']);
  }

  trasYearChange() {
    let selecetdYear = this.months.filter((a: any) => a.display == this.monthDisplay);
    this.year = selecetdYear[0].year;
    this.month = selecetdYear[0].number;
    let filterRange = this.commonService.getDateRange("Other Month", this.month, this.year);
    this.minDate = filterRange.startDate;
    this.maxDate = filterRange.endDate;
    this.toMinDate = filterRange.startDate;
    this.toMaxDate = filterRange.endDate;
    this.startDate = filterRange.startDate;
    this.endDate = filterRange.endDate;
    this.getData();
  }

  ChangeStore() {
    let store = this.storeList.filter((x: any) => x.StrID == this.store.id);
    if(store.length > 0) {
    this.store.id = store[0].StrID;
    this.StoreName = store[0].sNm;
    }
    this.getData();
  }

  ChangeTransType() {
    let trasType = this.transactionType.filter((x: any) => x.type == this.transType.name);
    this.transType.id = trasType[0].id;
    this.getData();
  }

  chnageUser() {
    let ChgUser = this.userList.filter((x: any) => x.UserID == this.user.id);
    if(ChgUser.length > 0) {
    this.user.id = ChgUser[0]?.UserID ? ChgUser[0]?.UserID : 0;
    this.userName = ChgUser[0]?.Name ? ChgUser[0]?.Name : '';
  }
    this.getData();
  }  

            
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Print Data
  printTranjection(id: number, xnTypeID: number = 0){
    var XnID: string = this.commonService.encryptData(id);
    let AgencyID: string = this.commonService.encryptData(this.jarvisData[0].AgencyIDs);
    let link = '';
    if (xnTypeID == 10) {
      link = 'BasicPrdPrint?XnID=' + XnID + "&aid=" + AgencyID;
    }
    else {
      link = 'transactionHistory?XnID=' + XnID + "&aid=" + AgencyID
    } 
    window.open(link, '_blank', 'Height= 800px, Width= 1000px, padding:10px, Top= 50px, Left= 100px, edge= Raised, center= Yes, help= No, resizable= No, status= No');
  }

  //export to excel
  exportToExcelActivities() {
    var html = "";

    html += "<table><tr>";
    html += "<th style='text-align: left;'>" + this.headerName + "</th>"
    html += "</table></tr>"; 
    // Blank Column
    html += "<table><tr></table></tr>";
    html += "<table><tr>";

    //Hader Title
    if(this.showDatePicker)
    {
      html += "<p><b> From : </b>"+ new Date(this.startDate).customFormat("#DD#-#MMM#-#YYYY#") + "<b>, To : </b>"+ new Date(this.endDate).customFormat("#DD#-#MMM#-#YYYY#") +  "<b>, Store : </b>"+ (this.store.id == 0 ? 'All' : this.StoreName) +  "<b>, Excecutive : </b>"+ (this.user.id == 0 ? 'All': this.userName) + "</p>"
    }
    else{
      html += "<p><b> Month : </b>"+ this.monthDisplay + "<b>, Store : </b>"+ (this.store.id == 0 ? 'All' : this.StoreName) +  "<b>, Excecutive : </b>"+ (this.user.id == 0 ? 'All': this.userName) + "</p>"
    }
    // Blank Column
    html += "<table><tr>";
    var strHeader = ""
    strHeader += "<th style='text-align: left;'>Date</th>";
    strHeader += "<th style='text-align: left;'>Xn No.</th>";
    var NewRec = (this.currXnTypeID == 8) ? true : false;
    if(NewRec){
      strHeader += "<th style='text-align: left;'>Store</th>";
    }
    var isstore = (this.currXnTypeID == 1 || this.currXnTypeID == 2 || this.currXnTypeID == 7) ? false : true;
    if(this.currXnTypeID != 8){
      if(isstore){
        strHeader += "<th style='text-align: left;'>Out Store</th>";
      }
    }
    var isnewstore = (this.currXnTypeID == 4 || this.currXnTypeID == 5) ? false : true;
    if(this.currXnTypeID != 8){
      if(isnewstore){
        strHeader += "<th style='text-align: left;'>In Store</th>";
      }
    }
    strHeader += "<th style='text-align: left;'>By</th>";
    var NewRecType = (this.currXnTypeID == 8) ? true : false;
    if(NewRecType){
      strHeader += "<th style='text-align: left;'>Type</th>";
    }
    if(this.currXnTypeID == 5 || this.currXnTypeID == 2 || this.currXnTypeID == 9 || this.currXnTypeID == 7 || this.currXnTypeID == 8){
      strHeader += "<th style='text-align: left;'>Note</th>";
    }
    if(this.currXnTypeID == 1){
      strHeader += "<th style='text-align: left;'>Supplier</th>";
    }  
    if(this.currXnTypeID == 4){
      strHeader += "<th style='text-align: left;'>Consignee</th>";
    } 
    
    // strHeader += "<th style='text-align: left;'>File</th>";
  
    strHeader += "</tr>"
    html += strHeader;
    var body = "";
    this.exportToExcel.forEach((item:any, key:any) => {
      body += "<tr>";
      item.Date = (item.Date == null) ? '-' : new Date(item.Date).customFormat("#DD#-#MMM#-#YYYY#");
      body += "<td style='text-align: left;'>" + item.Date + "</td>";
      body += "<td style='text-align: left;'>" + item.XnNo  + "</td>";
      if(NewRec){
        body += "<td style='text-align: left;'>" + item.storeName  + "</td>";
      }
      if(this.currXnTypeID != 8){
      if(isstore){
        body += "<td style='text-align: left;'>" + item.outStoreName  + "</td>";
      } 
    }
    if(this.currXnTypeID != 8){
      if(isnewstore){
        body += "<td style='text-align: left;'>" + item.inStoreName  + "</td>";
      }
    }
    body += "<td style='text-align: left;'>" + item.XnByUserName + "</td>";
      if(NewRecType){
        body += "<td style='text-align: left;'>" + (item.inStoreName ? 'in' : 'out')  + "</td>";
      }
      if(this.currXnTypeID == 5 || this.currXnTypeID == 2 || this.currXnTypeID == 9 || this.currXnTypeID == 7 || this.currXnTypeID == 8){
        body += "<td style='text-align: left;'>" + (item.XnNotes ? item.XnNotes : '-')  + "</td>";
      }  
      if(this.currXnTypeID == 1){
        body += "<td style='text-align: left;'>" + (item.Name ? item.Name : '-')  + "</td>";
      }  
      if(this.currXnTypeID == 4){
        body += "<td style='text-align: left;'>" + (item.Name ? item.Name : '-')  + "</td>";
      }   
      // body += "<td style='text-align: left;'>" + (item.XnFile ? item.XnFile : '-')  + "</td>";
     
    body += "</tr>";
    })
    html += body;
    html += "</table>";
    this.tableToExcel(html, 'Sheet1', this.headerName);
  }


  //openInvoice() - Open Invoice
  openInvoice(id: number, xnID: number){
    let typeName: string = "Supplier Invoices" //Invoices
          if(id == 4) {
            typeName = "Invoices"
          }
          let url: string = "";
          if (this.apiService.fn_isLiveURL() == true) {
            url = "../../main.html#/DocBuilder?isN=1&Type=" + typeName + "&xnID=" + xnID
          }
          else{
            url = "http://localhost:60228/main.html#/DocBuilder?isN=1&Type=" + typeName + "&xnID=" + xnID;
          }           
          window.location.href = url;
  }

  showDateRangePicker(){
    this.showDatePicker = !this.showDatePicker;
  }
  
 startDateChange(startDT: Date) {
  if (!startDT) return;

  this.startDate = startDT;
  this.toMinDate = startDT;

  // Reset endDate only if it's now before the new startDate
  if (this.endDate && startDT > this.endDate) {
    this.endDate = new Date(startDT); // clone to avoid reference issues
  }

  this.applyDateRangeFilter();
}

endDateChange(endDT: Date) {
  if (!endDT) return;

  if (this.startDate && this.startDate > endDT) {
    this.endDate = new Date(this.startDate);
  } else {
    this.endDate = new Date(endDT); // clone to avoid reference issues
  }

  this.applyDateRangeFilter();
}

applyDateRangeFilter() {
  const start = this.startDate ? new Date(this.startDate) : null;
  const end = this.endDate ? new Date(this.endDate) : null;

  if (start) start.setHours(0, 0, 0, 0);
  if (end) end.setHours(23, 59, 59, 999);

  // Always filter from the ORIGINAL full list, not dataSource.data
  const filtered = this.trasactionHistoryList.filter((item: any) => {
    const itemDate = new Date(item.XnDT);
    if (start && itemDate < start) return false;
    if (end && itemDate > end) return false;
    return true;
  });

  this.dataSource.data = filtered;

  // Reset paginator to first page after filter
  if (this.dataSource.paginator) {
    this.dataSource.paginator.firstPage();
  }
}
}

